<div class="card" id="chat2">
  <div class="card-header d-flex justify-content-between align-items-center p-3 text-white border-bottom-0"
       style="background-color: #31576c;">
    <h5 class="mb-0">Streaming Socket Test</h5>
    <button type="button" class="btn btn-primary btn-sm" data-mdb-ripple-color="dark"
            (click)="open()">Open Socket
    </button>
  </div>
  <div class="card-body" style="position: relative; height: 300px; width: 500px;">
    <ul class="list-group list-group-flush">
      <li class="list-group-item" *ngFor="let messageObject of webSocket.webSocketMessage">
        <div class="d-flex flex-row justify-content-start" *ngIf="messageObject.userRequest !== undefined">
          <p class="small p-2 ms-3 mb-1 rounded-3"
             style="background-color: #f5f6f7;width: 300px;">{{messageObject?.userRequest}}</p>
        </div>
        <div class="d-flex flex-row justify-content-end mb-4" *ngIf="messageObject.userResponse !== undefined">
          <p class="small p-2 me-3 mb-1 text-white rounded-3 bg-primary"
             style="width: 300px;">{{messageObject.userResponse}}</p>
        </div>
      </li>
    </ul>
  </div>
  <div class="card-footer text-muted d-flex justify-content-around p-3">
    <div>
      <textarea placeholder="Message to send..." class="form-control form-control-lg" [(ngModel)]="text"
                rows="3" style="max-height: 100px;width: 350px; border-width: 1px; border-color:gray;"></textarea>
    </div>
    <div class="row" style="width: 100px;">
      <button type="button" class="btn btn-light btn-rounded" style="margin-bottom: 10px;"
              (click)="sendMessage()">Send
      </button>
      <button type="button" class="btn btn-dark btn-rounded" (click)="close()">Close</button>
    </div>
  </div>
</div>
